module.exports = __webpack_public_path__ + "static/media/linkedin-in.933ba699.svg";